// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__tgDbT","header":"MessagesList_header__1al4D","chat":"MessagesList_chat__3CAg0"};